import React from 'react'
import { isObservable, observable } from 'mobx'
import { CollectionContext } from './collections'
import useOnOperationData from './hooks/use-on-operation-data'

export default function CollectionPayload ({ children, append = false }) {
  const collectionRef = React.useRef(observable.array())
  const collection = collectionRef.current

  function loadData (data) {
    if (typeof data.collection !== 'undefined') {
      if (!data.collection) {
        data.collection = []
      }

      if (data.collection.length > 0) {
        data.collection = data.collection.map(collectionEntry => {
          if (!isObservable(collectionEntry)) {
            collectionEntry = observable.map(Object.entries(collectionEntry))
          }

          return collectionEntry
        })
      }

      if (append === true) {
        collection.replace([...collection, ...data.collection])
      } else {
        collection.replace([...data.collection])
      }
    } else {
      collection.clear()
    }
  }

  useOnOperationData(data => {
    loadData(data)
  })

  return (
    <CollectionContext.Provider value={collection}>
      <>
        {children}
      </>
    </CollectionContext.Provider>
  )
}
